<mat-form-field appearance="fill" class="select-label">
  <mat-label>{{ titolo }}</mat-label>

  <input
    type="text"
    matInput
    [placeholder]="titolo"
    matInput
    [matAutocomplete]="auto"
    (keydown)="onKeyDown($event)"
    [formControl]="selectFormControl"
  />
  <mat-autocomplete #auto="matAutocomplete" [hideSingleSelectionIndicator]="true">
    <ng-container *ngFor="let padre of padri?.controls">
      <!--  SOLO PADRE -->
      <mat-option
        class="padre-class-select-custom"
        *ngIf="!$any(padre)?.controls?.figli?.controls?.length || nascondiFigli"
      >
        <mat-checkbox
          [formControl]="$any(padre)?.controls?.selected"
          (click)="$event.stopPropagation()"
          color="primary"
        >
          <div class="cont-titolo-expand" style="display: flex; align-items: center; width: 100%">
            {{ $any(padre)?.controls?.nomePadre?.value }}

            @if (!isBilancio) {
              -
              <a style="font-size: 12px; white-space: nowrap">{{
                $any(padre)?.controls?.descrizionePadre?.value
              }}</a>
              <!-- Codice -->
              <div class="codice-field" style="margin-left: 20px; flex-shrink: 0">
                <mat-form-field
                  appearance="outline"
                  (click)="$event.stopPropagation(); $event.preventDefault()"
                >
                  <mat-label>Codice</mat-label>
                  <input
                    matInput
                    placeholder="Codice"
                    [formControl]="$any(padre)?.controls?.tag"
                    (keydown.space)="$event.stopPropagation()"
                    (keydown.enter)="$event.stopPropagation()"
                  />
                </mat-form-field>
              </div>

              <!-- Norma -->
              <div class="norma-field" style="margin-left: 10px; flex-grow: 1">
                <mat-form-field
                  appearance="outline"
                  (click)="$event.stopPropagation(); $event.preventDefault()"
                  style="width: 100%"
                >
                  <mat-label>Norma</mat-label>
                  <input
                    matInput
                    placeholder="Norma"
                    [formControl]="$any(padre)?.controls?.norma"
                    (keydown.space)="$event.stopPropagation()"
                    (keydown.enter)="$event.stopPropagation()"
                  />
                </mat-form-field>
              </div>
            }
          </div>
        </mat-checkbox>
      </mat-option>

      <!--  PADRE CON FIGLIO -->
      <mat-optgroup
        class="optgroup-select-custom"
        *ngIf="$any(padre)?.controls?.figli?.controls?.length && !nascondiFigli"
      >
        <div style="display: flex">
          <mat-checkbox
            [formControl]="$any(padre)?.controls?.selected"
            (click)="$event.stopPropagation()"
            color="primary"
          >
            <div class="cont-titolo-expand">
              {{ $any(padre)?.controls?.nomePadre?.value }}
              - <a style="font-size: 12px">{{ $any(padre)?.controls?.descrizionePadre?.value }}</a>
            </div>
          </mat-checkbox>

          <div class="cont-expand-codice">
            @if (!isBilancio) {
              <div class="cnt-codice-norma">
                <!-- Codice -->
                <div class="codice-field" style="margin-left: 20px">
                  <mat-form-field appearance="outline">
                    <mat-label>Codice</mat-label>
                    <input
                      matInput
                      placeholder="Codice"
                      [formControl]="$any(padre)?.controls?.tag"
                    />
                  </mat-form-field>
                </div>

                <!-- Norma -->
                <div class="norma-field" style="margin-left: 10px">
                  <mat-form-field appearance="outline">
                    <mat-label>Norma</mat-label>
                    <input
                      matInput
                      placeholder="Norma"
                      [formControl]="$any(padre)?.controls?.norma"
                    />
                  </mat-form-field>
                </div>
              </div>
            }

            <!-- Expand -->
            <button
              *ngIf="$any(padre)?.controls?.figli?.controls?.length && !nascondiFigli"
              mat-button
              style="display: flex; justify-content: flex-end"
              (click)="expandFigli($any(padre)?.value)"
              [disabled]="$any(padre)?.controls?.selected?.status === 'DISABLED'"
            >
              <mat-icon>
                {{
                  !isFigliExpand[$any(padre)?.controls?.nomePadre?.value]
                    ? 'expand_less'
                    : 'expand_more'
                }}</mat-icon
              >
            </button>
          </div>
        </div>

        <!-- FIGLI -->
        <mat-option
          class="figli-class-select-custom"
          *ngFor="let figlio of $any(padre)?.controls?.figli?.controls"
          [ngClass]="
            !isFigliExpand[$any(padre)?.controls?.nomePadre?.value] ? 'list-show' : 'list-hide'
          "
        >
          <mat-checkbox
            [formControl]="$any(figlio)?.controls?.selected"
            (click)="$event.stopPropagation()"
          >
            {{ $any(figlio)?.controls?.nomeFiglio?.value }} -<a style="font-size: 12px">
              {{ $any(figlio)?.controls?.descrizioneFiglio?.value }}</a
            >
          </mat-checkbox>
        </mat-option>
      </mat-optgroup>
    </ng-container>
  </mat-autocomplete>
</mat-form-field>
